export const YOUTUBE_INSTALLATION_PATH = 'youtubeInstallation';
export const GOOGLE_INSTALLATION_PATH = 'googleInstallation';
